export default __webpack_public_path__ + "static/media/lrc-investment-lifecycle.cb3ac9a5.png";